<template>
  <div>
    <b-modal id="modal-social-create-user" ref="modalSocialCreateUser" title="Complemente seu cadastro" ok-title="Logar" cancel-title="Cancelar" @ok="createSocialUser">
      <div class="form-group">
        <div class="form-group mt-2">
          <label for="Cpf">Cpf</label>
          <input type="cpf" 
            :class="($v.cpf.$error || apiValidationsCpfErrors || errorCpfFormat)?'form-control is-invalid mt-2':'form-control mt-2'"
            id="cpf" 
            placeholder="CPF" 
            name="cpf" 
            v-model="cpf"
            v-mask="['###.###.###-##']"
            required 
            autofocus>
          <form-validation-invalid-feedback :field="$v.cpf" :text="{ required: 'Por favor informe o cpf' }" />
          <validation-message ref="validationMessageCpf"/>
        </div>
        <div class="form-group mt-4">
            <label for="periodoCadastro">Período atual</label>
            <select v-model="periodo" id="periodoCadastro" :class="($v.periodo.$error)?'form-control is-invalid mt-2':'form-control mt-2'">
                <option v-for="p in 12" :value="p" :key="p">
                {{p}}° período
                </option>
                <option value="13">Já sou formado</option>
                <option value="14">Não se aplica</option>
            </select>
            <small id="periodoHelp" class="form-text text-muted">O período nos ajuda a selecionar conteúdos direcionados</small>
            <form-validation-invalid-feedback :field="$v.periodo" :text="{ required: 'Por favor informe o período' }" />
        </div>
        <div class="form-group">
          <label for="faculdadeCadastro">Sua faculdade (opcional)</label>
          <vue-bootstrap-typeahead
              v-if="faculdades.length > 0"
              :serializer="item => item.faculdade+' - '+item.faculdadeSigla"
              :data="faculdades"
              :max-matches="100"
              :min-matching-chars="1"
              placeholder="ex: UFRJ"
              @hit="getFaculdade = $event"
              id="faculdadeEscolhida"
              class=""
          ></vue-bootstrap-typeahead>
        </div>
        <div class="form-group mt-4">
            <label for="telefoneCadastro">Telefone (opcional)</label>
            <input v-mask="['+55 (##) ####-####', '+55 (##) #####-####']" v-model="telefone" type="text" name="telefone" class="form-control mt-2" id="telefone" placeholder="(00)00000-0000">
        </div>
        <div class="custom-control custom-checkbox mt-4">
            <input type="checkbox" class="custom-control-input" v-model="termosUso" id="termosUso">
            <label class="custom-control-label" for="termosUso">Concordo com os <a :href="termoUsoUrl" target='_blank'>termos de uso</a></label>
              <div id="aceitePendente" class="invalid-feedback" :style="termoUsoErrorMessage?'display: inline-block':'display: none'">
                É necessário aceitar os termos
            </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import FormValidationInvalidFeedback from '@/components/formValidationInvalidFeedback'
import ValidationMessage from '@/components/validationMessage'
import { cpf } from 'cpf-cnpj-validator'
import PlataformApi from "@/services/plataformApi"

export default {
  name: 'ForgotPassword',
  components : {FormValidationInvalidFeedback, ValidationMessage},
  data() {
    return {
      termosUso: false,
      termoUsoErrorMessage: false,
      errorCpfFormat: false,
      getFaculdade: false,
      faculdades: []
    }
  },
  validations: {
    cpf: { required },
    periodo: { required }
  },
  computed: {
    cpf: {
      get () {
        return this.$store.getters.cpfSocialCreateUser
      },
      set (value) {
        this.$store.commit('setCpfSocialCreateUser', value)
      }
    },
    telefone: {
      get () {
        return this.$store.getters.telefoneSocialCreateUser
      },
      set (value) {
        this.$store.commit('setTelefoneSocialCreateUser', value)
      }
    },
    periodo: {
      get () {
        return this.$store.getters.periodoSocialCreateUser
      },
      set (value) {
        this.$store.commit('setPeriodoSocialCreateUser', value)
      }
    },
    faculdadeId: {
      get () {
        return this.$store.getters.faculdadeIdSocialCreateUser
      },
      set (value) {
        this.$store.commit('setFaculdadeIdSocialCreateUser', value)
      }
    },
    apiValidationsCpfErrors: {
      get () {
        if(this.$store.getters.errorsSocialCreateUser?.validations?.cpf){
          return this.$store.getters.errorsSocialCreateUser.validations.cpf[0]
        }else{
          return null
        }
      },
    },
    termoUsoUrl() {
      return process.env.VUE_APP_BASE_FILES_URL+process.env.VUE_APP_TERMO_USO_ATUAL_URL
    }
  },
  watch: {
    '$store.getters.createUserSocialLogin': async function() {
      if(this.$store.getters.createUserSocialLogin){
        this.faculdades = await PlataformApi.getFaculdades()
        this.$bvModal.show('modal-social-create-user')
      }
    },
    '$store.getters.errorsSocialCreateUser': function () {
      this.$refs.validationMessageCpf.dismissMessage()

      if(this.$store.getters.errorsSocialCreateUser?.api){
        this.$toast.open({
          message: 'Falha ao tentar logar',
          type: 'error'
        })
      }

      if(this.$store.getters.errorsSocialCreateUser?.validations?.cpf){
        this.$refs.validationMessageCpf.showMessage('Cpf em uso por outra conta.')
      }
    },
    'termosUso': function () {
      this.termoUsoErrorMessage = false
    },
    'getFaculdade': function(){
        if(this.getFaculdade){
          this.faculdadeId = this.getFaculdade.faculdadeId
        }else{
          this.faculdadeId = null
        }
    },
  },
  methods: {
    async createSocialUser (bvModalEvt) {
      bvModalEvt.preventDefault()
      this.$v.$touch()

      if(!this.termosUso){
        this.termoUsoErrorMessage = true
      }else{
        this.termoUsoErrorMessage = false
      }

      let cpfIsValid = this.validateCpfFormat()
      
      if (!this.$v.$invalid && this.termosUso && cpfIsValid ) {
        let loader = this.$loading.show()

        await this.$store.dispatch('createSocialUser')

        if(!this.$store.getters.errorsSocialCreateUser){
          this.$nextTick(() => {
            this.$bvModal.hide('modal-social-create-user')
          })
        }

        loader.hide()
      }
    },
    validateCpfFormat () {
      if(!this.cpf){
        this.$refs.validationMessageCpf.showMessage()
        this.errorCpfFormat = false
        return true 
      }

      if (cpf.isValid(this.cpf)) {
        this.$refs.validationMessageCpf.showMessage()
        this.errorCpfFormat = false
        return true
      } else {
        this.$refs.validationMessageCpf.showMessage("O CPF é inválido")
        this.errorCpfFormat = true
        return false
      }
    },
  }
}
</script>